// Default State

const isLocal = window.location.href.indexOf('localhost') >= 0;
const ABSOLUTE_URL = isLocal ? 'http://dev-acerstat.devup.cc' : '';
// const ABSOLUTE_URL = '';
const URL_ROOT = '/api';

export const state = {
    baseUrl: ABSOLUTE_URL,
    apiUrl: ABSOLUTE_URL + URL_ROOT,
};



// WEBPACK FOOTER //
// ./src/store/state.js